import { Wrapper } from 'AppReact';
import styled from 'styled-components';

export default Wrapper(styled.div`display: flex; width: 100%; flex-wrap: wrap; justify-content: flex-start; gap: 2px; padding: 0px 8px 15px 8px`)